"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeInline;

function removeInline(array) {
  for (var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    items[_key - 1] = arguments[_key];
  }

  items.forEach(function (item) {
    var index;

    while (~(index = array.indexOf(item))) {
      array.splice(index, 1);
    }
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyZW1vdmVJbmxpbmUiLCJhcnJheSIsIml0ZW1zIiwiZm9yRWFjaCIsIml0ZW0iLCJpbmRleCIsImluZGV4T2YiLCJzcGxpY2UiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9VdGlscy9yZW1vdmVJbmxpbmUuanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gcmVtb3ZlSW5saW5lKGFycmF5LCAuLi5pdGVtcykge1xuICBpdGVtcy5mb3JFYWNoKGl0ZW0gPT4ge1xuICAgIGxldCBpbmRleDtcblxuICAgIHdoaWxlICh+KGluZGV4ID0gYXJyYXkuaW5kZXhPZihpdGVtKSkpIHtcbiAgICAgIGFycmF5LnNwbGljZShpbmRleCwgMSk7XG4gICAgfVxuICB9KTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFlLFNBQVNBLFlBQVQsQ0FBc0JDLEtBQXRCLEVBQXVDO0VBQUEsa0NBQVBDLEtBQU87SUFBUEEsS0FBTztFQUFBOztFQUNwREEsS0FBSyxDQUFDQyxPQUFOLENBQWMsVUFBQUMsSUFBSSxFQUFJO0lBQ3BCLElBQUlDLEtBQUo7O0lBRUEsT0FBTyxFQUFFQSxLQUFLLEdBQUdKLEtBQUssQ0FBQ0ssT0FBTixDQUFjRixJQUFkLENBQVYsQ0FBUCxFQUF1QztNQUNyQ0gsS0FBSyxDQUFDTSxNQUFOLENBQWFGLEtBQWIsRUFBb0IsQ0FBcEI7SUFDRDtFQUNGLENBTkQ7QUFPRCJ9